export const webHosting = {
  title: 'Web Hosting',
  description: 'DirectAdmin hosting plans with NVMe storage, DDoS protection and free SSL.',
  features: {
    performance: {
      title: 'Performance',
      description: 'Ultra-fast NVMe SSD storage'
    },
    security: {
      title: 'Security',
      description: 'SSL certificate included'
    },
    backup: {
      title: 'Daily Backups',
      description: 'Automatic daily backups'
    },
    support: {
      title: '24/7 Support',
      description: 'Dedicated assistance always available'
    }
  },

  plans: {
    starter1: {
      title: 'Starter 1',
      price: '€1.99',
      specs: [
        '1GB RAM',
        '2GB NVMe SSD',
        '1 Website',
        'Backup: Not included',
        'SSL: Included'
      ]
    },
    starter2: {
      title: 'Starter 2',
      price: '€3.99',
      specs: [
        '2GB RAM',
        '5GB NVMe SSD',
        '3 Websites',
        'Backup: Not included',
        'SSL: Included'
      ]
    },
    starter3: {
      title: 'Starter 3',
      price: '€6.99',
      specs: [
        '3GB RAM',
        '10GB NVMe SSD',
        '5 Websites',
        'Backup: Not included',
        'SSL: Included'
      ]
    },

    advanced1: {
      title: 'Advanced 1',
      price: '€14.99',
      specs: [
        '4GB RAM',
        '100GB NVMe SSD',
        '10 Websites',
        'Backup: Included',
        'SSL: Included'
      ]
    },
    advanced2: {
      title: 'Advanced 2',
      price: '€24.99',
      specs: [
        '6GB RAM',
        '150GB NVMe SSD',
        '15 Websites',
        'Backup: Included',
        'SSL: Included'
      ]
    },
    advanced3: {
      title: 'Advanced 3',
      price: '€49.99',
      specs: [
        '12GB RAM',
        '300GB NVMe SSD',
        '30 Websites',
        'Backup: Included',
        'SSL: Included'
      ]
    }
  }
};
